<div
  class="container"
  #draggablePreview
  [class.show]="isShow"
  [style.transform]="
    'translate(' + translateX + 'px, ' + translateY + 'px' + ')'
  "
>
  <header>
    <div
      class="topHeader"
      [ngClass]="{ active: isDragged }"
      (mousedown)="onMouseDown($event)"
      (mouseup)="onMouseUp($event)"
      (mousemove)="onMouseMove($event)"
    >
      CHANNEL PREVIEW
      <div class="icons">
        <div
          class="enlarge"
          (click)="enterFullscreen()"
          inlineSVG="/assets/icons/large.svg"
        ></div>
        <div
          class="enlarge"
          (click)="openInNewTab()"
          inlineSVG="/assets/icons/open-new-tab.svg"
        ></div>
        <div
          class="close"
          inlineSVG="/assets/icons/x-close-pop.svg"
          (click)="close()"
        ></div>
      </div>
    </div>
    <div class="bottomHeader">
      {{ currentChannel?.name }}
      <div class="time">00:56:00:18</div>
    </div>
  </header>
  <section *ngIf="isShow" #fullscreenContainer class="fullscreen-container">
    <video
      #preview
      autoplay
      width="100%"
      height="100%"
      [poster]="'/assets/stream-preview-loader.gif'"
      [webrtc-src]="currentChannelPreview"
      (refreshChannelPreview)="onRefreshChannelPreview()"
      [muted]="currentChannel.isMuted"
    ></video>
    <!-- 
        <div *ngIf="showQualitySettings && isFullScreen()" class="quality-settings-fullscreen">
            <div *ngFor="let quality of getAvailableQualities()" class="single-quality-container">
                <div [ngStyle]="{'visibility': isChosenQuality(quality) ? 'visible' : 'hidden'}" class="success"
                    inlineSVG="/assets/icons/success.svg"></div>
                <div class="quality" (click)="changeQuality(quality)">{{quality}}</div>
            </div>
        </div> -->

    <div class="custom-video-controls" *ngIf="isFullScreen()">
      <div class="controls">
        <div class="controls-left">
          <div
            *ngIf="isPaused()"
            class="play"
            inlineSVG="/assets/icons/play.svg"
            (click)="togglePlay()"
          ></div>
          <div
            *ngIf="!isPaused()"
            class="play"
            inlineSVG="/assets/icons/pause.svg"
            (click)="togglePlay()"
          ></div>
          <div
            *ngIf="!isMuted()"
            class="sound"
            inlineSVG="/assets/icons/sound.svg"
            (click)="toggleMute()"
          ></div>
          <div
            *ngIf="isMuted()"
            class="muted"
            inlineSVG="/assets/icons/muted.svg"
            (click)="toggleMute()"
          ></div>
        </div>
        <div class="controls-right">
          <!-- <div class="settings" inlineSVG="/assets/icons/settings.svg" (click)="showQualitySettings = !showQualitySettings; changeDetectorRef.markForCheck()"></div> -->
          <div
            class="fullscreen"
            inlineSVG="/assets/icons/exit-fullscreen.svg"
            (click)="exitFullscreen()"
          ></div>
        </div>
      </div>
    </div>
  </section>
</div>
